var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('vue-ueditor-wrap',{attrs:{"config":_vm.config},on:{"ready":_vm.ready},model:{value:(this.content),callback:function ($$v) {_vm.$set(this, "content", $$v)},expression:"this.content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }